/**
 * Widget to display a simple message next to some sort of element (tooltip).
 * 
 * Calling:
 * $('element').fieldAlertWidget({
 * 		// Options
 * });
 * 
 * See the wrapper functions at the bottom of this file for more information
 */
(function($){
	$.widget('ui.floatMe', {
						
		/**
		 * Create the widget
		 */
		_create: function(){		
			if($.browser.msie){
				if(parseInt($.browser.version, 10) <= 8){
					return false;
				}
			}
						
			if(this.element.is('.float_d')) return false;
			this.element.addClass('float_d');
			
			// Options
			this.options = {
				original: {
					offset: this.element.offset(),
					width: this.element.width(),
					height: this.element.height(),
					margin: this.element.css('margin'),
					zindex: this.element.css('zIndex')
				}
			};
			
			// Create a placement object
			$('<div class="floating_replacement"></div>')
				.css({
					width: this.element.outerWidth(true) + 'px',
					height: this.element.outerHeight(true) + 'px',
					display: 'none'
				})
				.insertAfter(this.element);
			
			// Bind the scroll events
			this._bindEvents();
			this.element.data('floatingElmData', this.options.original);
		},
		
		/**
		 * Bind this element to the window
		 */
		_bindEvents: function(){
			$(window).bind('scroll.floatingelm', {floatingElm:this.element}, this.eventScroll);
		},
		
		/**
		 * Unbind the scroll event
		 */
		_unbindEvents: function(){
			$(window).unbind('scroll.floatingelm');
		},
		
		/**
		 * Unbind the event from the window
		 */
		unbind: function(){
			if($.browser.msie){
				if(parseInt($.browser.version, 10) <= 8){
					return false;
				}
			}
			
			this._unbindEvents();
			
			return this;
		},
		
		/**
		 * Bind the event to the window
		 */
		bind: function(){
			if($.browser.msie){
				if(parseInt($.browser.version, 10) <= 8){
					return false;
				}
			}
			
			this._bindEvents();
			$(window).trigger('scroll');
			
			return this;
		},
		
		/**
		 * The actual bound event
		 * @param event
		 */
		eventScroll: function(event){			
			var elm = event.data.floatingElm;
			if(!elm.is(':visible')) return false;
			
			var elmData = elm.data('floatingElmData'), 
				bodyY, elmY, elmIsFloating, elmOffsetOfBody, line;
			
			// Firstly figure out, where is the window currently sitting on the Y access?
			bodyY = parseInt($(window).scrollTop());
			
			// Find out where our element originally sat
			elmY = elmData.offset.top;
			
			// Is the element currently floating?
			elmIsFloating = elm.is('.isFloating');
			
			// Get the difference
			elmOffsetOfBody = bodyY - elmY;
			
			// Mark the line TODO: Make this optional
			line = 0;
			
			if(!elmIsFloating){
				// Element is not floating
				if(elmOffsetOfBody > line){
					// Below the line, instead float the body to the line
					elm.css({
						position: 'fixed',
						top: line + 'px',
						width: elmData.width,
						zIndex: 3000						
					})
						.addClass('isFloating')
						.next('.floating_replacement').show();
				}
			}
			else {
				// Element is currently floating
				if(elmOffsetOfBody < line){
					// Above the line, revert back
					elm.css({
						position: 'relative',
						top: 0,
						zIndex: elmData.zindex
					})
						.removeClass('isFloating')
						.next('.floating_replacement').hide();
				}
			}
		},
		
		/**
		 * Force the element back to it's normal place
		 * @returns {Boolean}
		 */
		restore: function(){
			if($.browser.msie){
				if(parseInt($.browser.version, 10) <= 8){
					return false;
				}
			}
			
			var elm = this.element;
			if(!elm.is(':visible')) return false;
			
			var elmData = elm.data('floatingElmData');
			elm.css({
				position: 'relative',
				top: 0,
				zIndex: elmData.zindex
			});
			elm.next('.floating_replacement').hide();
			
			return this;
		}
	});
})(jQuery);